import constants from './constants';

const setCreateEditBusinessType = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_BUSINESSTYPE,
    payload: values,
  });

};

const setBusinessTypeIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_BUSINESSTYPE_ID_TO_EDIT,
    payload: values,
  });

};

export default {
  setCreateEditBusinessType,
  setBusinessTypeIdEdit,
};
